import {
    getField,
    updateField
} from "vuex-map-fields"
import {
    ADD_ROW, REMOVE_FILE_IN_FILES, RESET_FORM, SET_FILES, SET_FORMS
} from "../../constant-types"

const getDefaultState = () => {
    return {
        pictures: [],
        new_pictures: []
    }
}

const getDefaultRowState = () => ({
    id: '',
    caption: '',
    file_path: ''
})

export default ({
    namespaced: true, 
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [ADD_ROW](state) {
            state.pictures.push(getDefaultRowState())
        },
        [RESET_FORM](state) {
            Object.assign(state, getDefaultState())
        },
        [SET_FORMS](state, pictures) {
            Object.assign(state.pictures, pictures)
        },
        [SET_FILES](state, refFiles) {
            // add pictures
            for (let i = 0; i < refFiles.length; i++) {
                let reader = new FileReader()
                reader.onload = e => {
                    state.new_pictures.push({ caption : '', file_path : e.target.result, file : refFiles[i] })
                }
                reader.readAsDataURL(refFiles[i])
            }
        },
        [REMOVE_FILE_IN_FILES](state, payload) {
            state[payload.field].splice(payload.fileIndex, 1);
        },
        updateField

    },
    // can async
    actions: {

    },
    // call variable with custom display
    getters: {
        getField
    }
})